import { render, staticRenderFns } from "./InitLoading.vue?vue&type=template&id=73955286&scoped=true&"
import script from "./InitLoading.vue?vue&type=script&lang=js&"
export * from "./InitLoading.vue?vue&type=script&lang=js&"
import style0 from "./InitLoading.vue?vue&type=style&index=0&id=73955286&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73955286",
  null
  
)

export default component.exports